export default __webpack_public_path__ + "static/media/icon-trailer.8c998e89.svg";